import { createContext, useReducer, Dispatch, FunctionComponent } from 'react';
import reducer, { Actions } from './reducer';
import StackdriverErrorReporter from 'stackdriver-errors-js';
import { AppState } from '../types/AppState';

export const initialState = {
  id: 0,
  content: [],
  labels: [],
  selectedBboxes: [],
  visibleLabels: [],
  mode: 'tag',
  history: {
    steps: [],
    current: 0
  },
  loading: false,
  labeling: true,
  defaultLanguage: process.browser ? navigator.language.split('-')[0] : 'es',
  dirtyCounts: {
    added: 0,
    modified: 0,
    removed: 0
  },
  startTime: Date.now(),
  query: {},
  box_manipulation: false,
  query_category_id: Number.NaN,
  category_id: Number.NaN,
  errorHandler: new StackdriverErrorReporter()
} as AppState;

export const store = createContext<{
  state: AppState;
  dispatch: Dispatch<Actions>;
}>({
  state: initialState,
  dispatch: () => null
});

export const StoreProvider: FunctionComponent = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const { Provider } = store;
  return <Provider value={{ state, dispatch }}>{children}</Provider>;
};
